module.exports = __webpack_public_path__ + "img/mobile.e16ee8a2.svg";